export const CREDENTIAL_TYPES = {
  DEFAULT: "default",
  NEW: "new",
};

export const GALLERY_IMAGE_TYPE = "gallery";
export const CUSTOM_IMAGE_TYPE = "custom";
